import {Swiper, Pagination} from 'swiper';
import {isSafari} from './helper';

Swiper.use([Pagination]);
import simpleParallax from 'simple-parallax-js';
import Rellax from 'rellax';
import {beforeEffectSlider} from './vendor/before-effect-slider';
import {VideoPlayer} from './video-plyr';
import LazyLoad from 'vanilla-lazyload';

const playVideo = (video) => {
  let videoPlayer = VideoPlayer(video);
  if (isSafari() && video.autoplay) {
    // safari ignores autoplay on, so we force it here
    videoPlayer.play();
  }
};

function toggleVisibilityOfElementsDependingOnCurrentlyShowingTab(target) {
  if (target.parentElement?.querySelector('[data-hideelementswhileshowingthistab]')) {
    document.querySelectorAll('.hidden-by-carousel-slider.hidden').forEach(el => {
      el.classList.remove('hidden');
      el.classList.remove('hidden-by-carousel-slider');
    });
  }
  if (target.dataset.hideelementswhileshowingthistab) {
    document.querySelectorAll(target.dataset.hideelementswhileshowingthistab).forEach(el => {
      el.classList.add('hidden');
      el.classList.add('hidden-by-carousel-slider');
    });
  }
}

const applyTabCarousel = (tabCarousel) => {
  const tabs = tabCarousel.querySelectorAll('[role="tab"]');
  const autoRotateSlider = () => tabCarousel.classList.add('auto-rotate-slider');

  tabCarousel
    .querySelectorAll('[role="tabpanel"] > *')
    .forEach((el) => {
      el.removeEventListener('mouseleave', autoRotateSlider);
      el.addEventListener('mouseleave', autoRotateSlider);
    });

  const intervalInSeconds = tabCarousel.getAttribute('data-slideshow-duration') ? Number(tabCarousel.getAttribute('data-slideshow-duration')) : 5;

  const stopRotation = () => {
    tabCarousel.classList.remove('auto-rotate-slider');
  };
  const displayNextSlide = () => {
    const selectedTabButton = tabCarousel.querySelector('[role="tablist"] [role="tab"][aria-selected="true"]');
    if (selectedTabButton && selectedTabButton.nextElementSibling.getAttribute('role') === 'tab') {
      selectedTabButton.nextElementSibling.dispatchEvent(new Event('showTab'));
    } else {
      tabCarousel.querySelector('[role="tab"]:first-of-type').dispatchEvent(new Event('showTab'));
    }
  };

  // source: https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Roles/Tab_Role
  function changeCarouselTabOnClick(e) {
    const target = e.target;
    const parent = target.parentNode;
    const grandparent = parent.parentNode;

    const tabsCount = [...parent.querySelectorAll('[role="tab"]')].length;
    const tabCarousel = target.closest('.tabs-carousel');

    // animate loading indicator
    const slider = parent.querySelector('.slider');
    let progressBar = slider.querySelector('.progress-bar');
    const position = Number(e.target.getAttribute('data-pos'));
    const progressInPercentage = position * 100 / tabsCount;

    toggleVisibilityOfElementsDependingOnCurrentlyShowingTab(e.target);

    if (e.isTrusted) {
      // click by a human (or at least not programmatically)
      stopRotation();
    }

    // display indicator progress animation
    if (tabCarousel.classList.contains('auto-rotate-slider') && position === 1) {
      // if progress bar reaches 100% it needs to be removed and recreated
      // otherwise the animation of the progress bar will be messed up
      progressBar.remove();
      progressBar = document.createElement('div');
      progressBar.classList.add('progress-bar');
      slider.appendChild(progressBar);
      setTimeout(() => progressBar.style.width = `${progressInPercentage}%`, 100);
    } else {
      progressBar.style.width = `${progressInPercentage}%`;
    }


    // Remove all current selected tabs
    parent
      .querySelectorAll('[aria-selected="true"]')
      .forEach(t => t.setAttribute('aria-selected', false));

    // trigger click if click on tab
    let swiperDot = tabCarousel.querySelector('.swiper-pagination-bullets').children[Number(target.getAttribute('data-pos')) - 1];
    if (swiperDot) {
      swiperDot.click();
    }

    // Set this tab as selected
    target.setAttribute('aria-selected', true);

    // Hide all tab panels
    grandparent
      .querySelectorAll('[role="tabpanel"]')
      .forEach(p => p.setAttribute('hidden', true));

    // Show the selected panel
    grandparent.parentNode
      .querySelector(`#${target.getAttribute('aria-controls')}`)
      .removeAttribute('hidden');

    const selectedTabContent = tabCarousel.querySelector('[role="tablist"] [role="tabpanel"]:not([hidden="true"])');
    if (tabCarousel.classList.contains('display-current-selected-image-as-background')) {
      let imageUrl = '';
      if (window.devicePixelRatio > 1.0) {
        imageUrl = selectedTabContent.querySelector('.images img').getAttribute('data-tabs-src-retina');
      } else {
        imageUrl = selectedTabContent.querySelector('.images img').getAttribute('data-tabs-src');
      }
      tabCarousel.style.backgroundImage = `url(${imageUrl})`;
    }

    autoplayVideos(selectedTabContent);
  }

  tabs.forEach((tab, i) => {
    tab.removeEventListener('showTab', changeCarouselTabOnClick);
    tab.addEventListener('showTab', changeCarouselTabOnClick);

    tab.removeEventListener('click', changeCarouselTabOnClick);
    tab.addEventListener('click', changeCarouselTabOnClick);
  });
  if (tabCarousel.classList.contains('auto-rotate-slider')) {
    setInterval(() => {
      if (!tabCarousel.classList.contains('auto-rotate-slider')) {
        // auto slider is set to inactive
        return null;
      }
      displayNextSlide();
    }, intervalInSeconds * 1000);
  }
  // timeout is required to wait for swipers' initialization
  setTimeout(() => displayNextSlide(), 100);
  tabCarousel
    .querySelectorAll('[role="tabpanel"] > *')
    .forEach((el) => {
      el.removeEventListener('mousemove', stopRotation, { passive: true });
      el.addEventListener('mousemove', stopRotation, { passive: true });
    });
  tabCarousel
    .querySelectorAll('.auto-rotate-slider .swiper-container')
    .forEach((el) => {
      el.removeEventListener('touchstart', stopRotation, { passive: true });
      el.addEventListener('touchstart', stopRotation, { passive: true });
    });

};

const tabCarouselWithSwiper = (tabCarousel) => {
  applyTabCarousel(tabCarousel);
  // preload all images if all other images on the page are already loaded
  tabCarousel.querySelectorAll(' .images img').forEach((el) => LazyLoad.load(el));


  let swiper = new Swiper(tabCarousel.querySelector('.swiper-container'), {
    init: false,
    pagination: {
      el: '.dots',
      clickable: true
    }
  }).on('slideChange', function (swiper) {
    let tabCarousel = swiper.el.closest('.tabs-carousel');
    let buttons = tabCarousel.querySelectorAll('.tabs button');
    let i = swiper.realIndex;
    let tabs = tabCarousel.querySelector('.tabs');
    buttons.forEach((e) => e.setAttribute('aria-selected', false));
    buttons[i].setAttribute('aria-selected', true);
    autoplayVideos(swiper.el);

    toggleVisibilityOfElementsDependingOnCurrentlyShowingTab(buttons[i]);

    // scroll buttons
    tabs.scroll(buttons[i].getBoundingClientRect().width * i, 0);
  }).on('init', (swiper) => {
    autoplayVideos(swiper.el);
  });
  swiper.init();

  if (window.location.hash) {
    // display tab if hash is selected
    const selectedTab = tabCarousel.querySelector(`button[role="tab"]${window.location.hash}`);
    if (selectedTab) {
      setTimeout(() => selectedTab.click(), 100);
      window.scrollTo({
        top: document.querySelector(`${window.location.hash}`)?.getBoundingClientRect()?.top,
        behavior: 'instant'
      });
    }
  }
};

function movingBordersEffect(el) {
  // https://stackoverflow.com/a/32623832/728804
  function absolutePositionOfElement(el) {
    if (!absolutePositionOfElement.offsetBase) {
      absolutePositionOfElement.offsetBase = {};
    }
    if (!el.getAttribute('data-cached-absolute-position-id')) {
      el.setAttribute('data-cached-absolute-position-id', Math.random().toString(36).substring(2) + Date.now().toString(36));
    }
    let id = (!el.getAttribute('data-cached-absolute-position-id'));
    let found = false;
    let left = 0;
    let top = 0;
    let width = 0;
    let height = 0;
    let offsetBase = absolutePositionOfElement.offsetBase[id];

    if (!offsetBase && document.body) {
      offsetBase = absolutePositionOfElement.offsetBase[id] = document.createElement('div');
      offsetBase.style.cssText = 'position:absolute;left:0;top:0';
      document.body.appendChild(offsetBase);
    }
    if (el && el.ownerDocument === document && 'getBoundingClientRect' in el && offsetBase) {
      let boundingRect = el.getBoundingClientRect();
      let baseRect = offsetBase.getBoundingClientRect();
      found = true;
      left = boundingRect.left - baseRect.left;
      top = boundingRect.top - baseRect.top;
      width = boundingRect.right - boundingRect.left;
      height = boundingRect.bottom - boundingRect.top;
    }
    return {
      found,
      left,
      top,
      width,
      height,
      right: left + width,
      bottom: top + height
    };
  }

  let height = el.clientHeight;

  let overlap = absolutePositionOfElement(el).top - window.scrollY;
  let percentage = (window.innerHeight - overlap) * (100 / height);

  let borderWith = null;
  if (percentage > 0 && percentage <= 100) {
    borderWith = `${((window.innerWidth / 2) / 100) * (100 - percentage)}px`;
  } else if (percentage < 0) {
    borderWith = `${window.innerWidth / 2}px`;
  } else {
    borderWith = `0px`;
  }
  el.style.borderWidth = borderWith;
}

const autoplayVideos = (selector) => selector.querySelectorAll('video').forEach(playVideo);

const applySimpleParallaxOnElement = (el) => {
  new simpleParallax(el, {
    orientation: el.getAttribute('data-parallaxOrientation') || 'up',
    overflow: true
  });
};

// can always be replaced with lodash's _.debounce
// https://gist.github.com/nmsdvid/8807205#gistcomment-2595895
const debounceEvent = (callback, time, interval) => (...args) => {
  clearTimeout(interval);
  interval = setTimeout(() => callback(...args), time);
};

const imageComparisonSlider = (Element) => {
  if (window.devicePixelRatio > 1.0) {
    beforeEffectSlider({
      Element,
      BeforeImage: Element.getAttribute('data-first-image-retina-src'),
      AfterImage: Element.getAttribute('data-second-image-retina-src')
    });
  } else {
    beforeEffectSlider({
      Element,
      BeforeImage: Element.getAttribute('data-first-image-src'),
      AfterImage: Element.getAttribute('data-second-image-src')
    });
  }
};

const onDOMContentLoaded = () => {
  // docs: https://dixonandmoe.com/rellax/
  document.querySelectorAll('.rellax:not(.rellax-initialized)').forEach((el) => {
    el.classList.add('rellax-initialized');
    new Rellax(el);
  });
  document.querySelectorAll('video').forEach(playVideo);
  document.querySelectorAll('.parallax').forEach(applySimpleParallaxOnElement);
  document.querySelectorAll('.image-comparison-slider').forEach(imageComparisonSlider);
  document.querySelectorAll('.tabs-carousel').forEach(tabCarouselWithSwiper);
};

const scrollEvents = () => document.querySelectorAll('.moving-side-border').forEach(movingBordersEffect);

window.addEventListener('scroll', debounceEvent(scrollEvents, 5), { passive: true });

export default onDOMContentLoaded;
